import React from 'react';
import PropTypes from 'prop-types';
import TPTypography from 'components/TP-UI/TPTypography';

const EconomicCalendarDisclaimer = ({ content }) => {
  return <TPTypography variant="body2">{content}</TPTypography>;
};

EconomicCalendarDisclaimer.propTypes = {
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
};

export default EconomicCalendarDisclaimer;
